/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-27 14:14:32
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 16:40:16
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/index.tsx
 */
import React from 'react';
import { useParams } from 'react-router-dom';
//import { useDispatch } from 'react-redux';
import { dispatch } from 'src/store';

import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import { PreviewWrapper } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import PageWrapper from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import CloneBtn from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/CloneButton';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
import TopLeaderBoardBanner from './TopLeaderBoardBanner';
import Menu from './Menu';
import Preview from './Preview';
import MiniInfo from './MiniInfo';
import MiniShare from './MiniShare';
import GridSetting from './GridSetting';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { ChannelType } from 'src/types/common/SalesChannel';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import { getContentButtonThemes } from 'src/request/salesChannel/content';
import {
  fetchContentAllProductsPage,
  submitContentAllProductsPage,
  validation,
  getState,
  getHasModified,
  resetData,
  getSalesChannel,
  getSalesChannelName,
  getLoaded,
} from './slice';
import { convertDataFromReduxToServer } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAllProductPage/tools';
import { PreviewStyleSwitch } from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import { EPreviewSize, WebSiteSubType } from '@/src/types/common/SalesChannel';

const SalesChannelEditorAllProductPage = (props) => {
  //const _h = useHistory();
  const {
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    onDiscard,
    onGoBack,
    loaded,
    isOnPrimaryLanguage,
    currentSize,
    currentStyle,
    isMini,
  } = props;

  //const _d = useDispatch();
  const _params: {
    saleChannelUuid: string;

    contentUuid: string;
  } = useParams();
  const { contentUuid } = _params;

  const [themeList, setThemesList] = React.useState([]);
  React.useEffect(() => {
    getContentButtonThemes(contentUuid).then((res) => {
      setThemesList(res);
      //console.log(res);
    });
  }, []);

  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });
  const type = useSalesChannelType();

  const _miniProgramRender = () => {
    return (
      <React.Fragment>
        {!isOnPrimaryLanguage && <CloneBtn />}
        <TopLeaderBoardBanner salesChannelContentUuid={contentUuid} />
        <Menu salesChannelContentUuid={contentUuid} linkSet={linkSet} />
        <MiniShare />
        <MiniInfo />
      </React.Fragment>
    );
  };
  const _websiteRender = () => {
    const isConvertible =
      currentStyle === WebSiteSubType.ResponsivePage &&
      (currentSize === EPreviewSize.TABLET ||
        currentSize === EPreviewSize.MOBILE);
    return (
      <React.Fragment>
        {!isOnPrimaryLanguage &&
          currentStyle === WebSiteSubType.NativeMobile && <CloneBtn />}
        <TopLeaderBoardBanner
          isConvertible={isConvertible}
          isResponsive={currentStyle === WebSiteSubType.ResponsivePage}
          salesChannelContentUuid={contentUuid}
        />
        {!isConvertible && (
          <Menu salesChannelContentUuid={contentUuid} linkSet={linkSet} />
        )}
        {isOnPrimaryLanguage && <GridSetting themeList={themeList} />}
      </React.Fragment>
    );
  };
  const renderContent = () => {
    if (type === ChannelType.MiniProgram) {
      return _miniProgramRender();
    }
    if (type === ChannelType.Website) {
      return _websiteRender();
    }
    return null;
  };

  React.useEffect(() => {
    return () => {
      dispatch(resetData());
    };
  }, []);

  return (
    <React.Fragment>
      {/* <RouteBlock hasModified={hasModified} /> */}
      <PageWrapper
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName: salesChannelName,
          onDiscard,
          onGoBack,
          hasStyleSelect: !isMini && true,
        }}
        leftChild={
          loaded ? (
            <PreviewStyleSwitch
              style={currentStyle}
              styleChild={
                <div
                  style={{
                    height: 10000,
                    backgroundColor: 'yellow',
                    // margin: '0 auto',
                  }}>
                  123
                </div>
              }
              normalChild={
                <PreviewWrapper>
                  <Preview />
                </PreviewWrapper>
              }
            />
          ) : null

          // <PreviewWrapper>
          //   <Preview />
          // </PreviewWrapper>
        }
        rightChild={
          loaded ? (
            <RightConfigWrapper
              title={'All Products Page'}
              elements={[
                {
                  body: <React.Fragment>{renderContent()}</React.Fragment>,
                  key: 'TopConfig',
                },
              ]}
            />
          ) : null
        }
      />
    </React.Fragment>
  );
};
export default BasicPageHOC(SalesChannelEditorAllProductPage, {
  getState,
  siteStyleInParams: true,
  previewSizeInParams: true,
  convertDataFromReduxToServer,
  submit: submitContentAllProductsPage,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  validation,
  getLoaded,
  hasRouteBlock: true,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchContentAllProductsPage({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
